import React, { useEffect, useState } from "react";
import TableFixedPage from "../../TableFixedPage/TableFixedPage";
import { errorToast, succToast } from "../../../Utils/Toast/Toast";
import {
  createPrivateDiscountApi,
  getPrivateDiscountListApi,
} from "../../../Api/PanelAdminServices";
import Button from "../../Button/Button";
import { Modal } from "react-bootstrap";
import CreatePrivateDiscountCodeForm from "../../Forms/CreatePrivateDiscountCodeForm/CreatePrivateDiscountCodeForm";
import PrivateDiscountListTabel from "../../Tables/Discount/PrivateDiscountListTabel/PrivateDiscountListTabel";

const PrivateDiscountListContainer = () => {
  const [discountListState, setDiscountListState] = useState([]);
  const [showDeleteModalState, setShowmodalState] = useState(false);
  const [showEditModalState, setShowEditModalState] = useState(false);
  const [disableRemove, setDisableRemove] = useState(false);
  const [DiscountDetailState, setDiscountDetailState] = useState();
  useEffect(() => {
    getInitialDataHandler();
  }, []);
  const getInitialDataHandler = () => {
    getPrivateDiscountListApi((res) => {
      if (res.status === 0) {
        errorToast(res.message);
      } else {
        setDiscountListState(res.discount_stock);
      }
    });
  };
  const HideModlaHandler = () => {
    setShowmodalState(false);
    setShowEditModalState(false);
  };

  const showModalHandler = (value, data) => {
    setDiscountDetailState(data);
    if (value === 2) {
      setShowmodalState(true);
    }
    if (value === 1) {
      setShowEditModalState(true);
    }
  };
  const RemoveDiscountHandler = () => {
    let bodyDetail = {
      action: "delete",
      id: DiscountDetailState.id,
      discount: DiscountDetailState.discount,
    };
    createPrivateDiscountApi(bodyDetail, (succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast(res.message);
          setDisableRemove(false);
        } else {
          succToast("با موفقیت حذف شد!");
          getInitialDataHandler();
          setDisableRemove(false);
          HideModlaHandler();
        }
      } else {
        console.error(res);
        setDisableRemove(false);
      }
    });
  };
  return (
    <section className="w-100">
      <Modal show={showDeleteModalState} onHide={HideModlaHandler}>
        <Modal.Header>
          <Modal.Title
            style={{ fontSize: "1rem", width: "100%", direction: "rtl" }}
          >
            آیا از حذف تخفیف موردنظر مطمئن هستید؟
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-around",
            }}
          >
            <Button
              ClassBtn={"rejectBtn"}
              Value={"خیر"}
              ClickHandler={HideModlaHandler}
            />
            <Button
              ClassBtn={"confirmBtn"}
              Value={"بله"}
              ClickHandler={RemoveDiscountHandler}
              disabledprops={disableRemove}
            />
          </div>
        </Modal.Body>
      </Modal>
      <Modal show={showEditModalState} onHide={HideModlaHandler} size="xl">
        <Modal.Header>
          <Modal.Title
            style={{ fontSize: "1rem", width: "100%", direction: "rtl" }}
          >
            ویرایش تخفیف
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CreatePrivateDiscountCodeForm
            mode="Edit"
            detail={DiscountDetailState}
            updateHanlder={() => {
              HideModlaHandler();
              getInitialDataHandler();
            }}
          />
        </Modal.Body>
      </Modal>
      <TableFixedPage title={"لیست کد تخفیف شخصی"} />
      <PrivateDiscountListTabel
        data={discountListState}
        openModal={showModalHandler}
      />
    </section>
  );
};

export default PrivateDiscountListContainer;
